import * as React from 'react';

import SlSkeleton from '@shoelace-style/shoelace/dist/react/skeleton';

import { InsightsBorderContainer } from './layout/InsightsBorderContainer';
import { InsightsFlexContainer } from './layout/InsightsFlexContainer';

export function InsightsLoading() {
  return (
    <InsightsBorderContainer>
      <InsightsFlexContainer>
        <SlSkeleton className="square w-full sm:w-1/3 h-8" effect="sheen" />
        <SlSkeleton className="square w-full sm:w-1/2 h-8" effect="sheen" />
        <SlSkeleton className="square w-full sm:w-1/4 h-8" effect="sheen" />
      </InsightsFlexContainer>
    </InsightsBorderContainer>
  );
}
